import { Link } from "react-router-dom";
import PublicFooter from "@/components/PublicFooter";

const PLATFORM_CONTACT = process.env.REACT_APP_PLATFORM_CONTACT_EMAIL || "info@jobsbook.app";

/**
 * Marketing-page footer. Composes with existing <PublicFooter/> for the
 * required legal links (Terms / Privacy) so we don't diverge from the
 * app footer.
 */
export default function LandingFooter() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="bg-primary text-primary-foreground border-t border-primary-foreground/10"
      data-testid="landing-footer"
    >
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <div className="h-8 w-8 rounded-md bg-accent grid place-items-center text-accent-foreground font-black text-lg">
                J
              </div>
              <span className="font-black tracking-tight text-lg">
                JobsBook<span className="text-accent">.</span>
              </span>
            </div>
            <p className="mt-4 text-sm text-primary-foreground/60 leading-relaxed max-w-sm">
              Bookings, staff scheduling, and invoicing for field service crews. Built in Ireland.
            </p>
            <a
              href={`mailto:${PLATFORM_CONTACT}`}
              className="mt-4 inline-block text-sm mono text-primary-foreground/70 hover:text-accent underline-offset-4 hover:underline"
              data-testid="landing-footer-email"
            >
              {PLATFORM_CONTACT}
            </a>
          </div>

          {/* Product links */}
          <div>
            <div className="mono text-[10px] uppercase tracking-[0.3em] text-primary-foreground/40 mb-4">
              Product
            </div>
            <ul className="space-y-2.5 text-sm">
              <li><a href="#features" className="text-primary-foreground/70 hover:text-primary-foreground">Features</a></li>
              <li><a href="#product"  className="text-primary-foreground/70 hover:text-primary-foreground">How it works</a></li>
              <li><a href="#pricing"  className="text-primary-foreground/70 hover:text-primary-foreground">Pricing</a></li>
              <li><a href="#faq"      className="text-primary-foreground/70 hover:text-primary-foreground">FAQ</a></li>
            </ul>
          </div>

          {/* Account links */}
          <div>
            <div className="mono text-[10px] uppercase tracking-[0.3em] text-primary-foreground/40 mb-4">
              Account
            </div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/signup" className="text-primary-foreground/70 hover:text-primary-foreground" data-testid="landing-footer-signup">Start free trial</Link></li>
              <li><Link to="/login"  className="text-primary-foreground/70 hover:text-primary-foreground" data-testid="landing-footer-signin">Sign in</Link></li>
              <li><Link to="/billing" className="text-primary-foreground/70 hover:text-primary-foreground">Billing</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-foreground/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-xs mono text-primary-foreground/50">
            © {year} JobsBook. All rights reserved.
          </div>
          <div className="text-xs text-primary-foreground/50" data-testid="landing-powered-by">
            Powered by{" "}
            <a
              href="https://yourdataapp.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-foreground/80 hover:text-accent"
            >
              YourDataApp.com
            </a>
          </div>
        </div>

        <div className="mt-6">
          <PublicFooter tone="light" />
        </div>
      </div>
    </footer>
  );
}
